/**
 This form groups together fields that are pre populated from a selected plot in an event
**/

import React, { useState } from 'react';
import {
  TextInput,
  required,
  NumberInput,
  ImageInput,
  SelectInput
} from 'react-admin';
import { useForm } from 'react-final-form';
import { validateFourStringCode, validateFourStringCodeOptional } from '../../../../src/utils/validation';
import { columnStyles } from 'styles';
import RichTextInput from 'ra-input-rich-text';
import { RichTextToolbar } from '../../../../src/utils/toolbarOptions';
import { PreviewImageField } from 'Components';
import { evidenceNumber, evidenceUnlockChoices } from 'utils/choices';

const validateCode = [required(), validateFourStringCode];
const validateCodeOptional = [validateFourStringCodeOptional];

const EventPlotForm = ({ plot, iscompleted, ...props }) => {
  const formData = useForm();
  const form = columnStyles('column', '30vw');

  if (plot) {
    formData.change('evidenceCode1', plot.evidenceCode1)
    formData.change('evidenceCode2', plot.evidenceCode2)
    formData.change('evidenceCode3', plot.evidenceCode3)
    formData.change('evidenceCode4', plot.evidenceCode4)
    formData.change('evidenceCode5', plot.evidenceCode5)
    formData.change('evidenceCode6', plot.evidenceCode6)
    formData.change('evidenceCode7', plot.evidenceCode7)
    formData.change('evidenceCode8', plot.evidenceCode8)
    formData.change('evidenceCode9', plot.evidenceCode9)
    formData.change('evidenceCode10', plot.evidenceCode10)
    formData.change('evidenceUnlock1', plot.evidenceUnlock1 || 'silver-lock')
    formData.change('evidenceUnlock2', plot.evidenceUnlock2 || 'silver-lock')
    formData.change('evidenceUnlock3', plot.evidenceUnlock3 || 'silver-lock')
    formData.change('evidenceUnlock4', plot.evidenceUnlock4 || 'silver-lock')
    formData.change('evidenceUnlock5', plot.evidenceUnlock5 || 'silver-lock')
    formData.change('evidenceUnlock6', plot.evidenceUnlock6 || 'silver-lock')
    formData.change('evidenceUnlock7', plot.evidenceUnlock7 || 'silver-lock')
    formData.change('evidenceUnlock8', plot.evidenceUnlock8 || 'silver-lock')
    formData.change('evidenceUnlock9', plot.evidenceUnlock9 || 'silver-lock')
    formData.change('evidenceUnlock10', plot.evidenceUnlock10 || 'silver-lock')
    formData.change('suspectsCode', plot.suspectsCode)
    formData.change('attendingActors', plot.maxActors)
    formData.change('discountCode', plot.discountCode)
    formData.change('plotImage', plot.image)
    formData.change('plotIntroduction', plot.description)
    formData.change('dressCode', plot.dressCode)
    formData.change('numberOfEvidence', plot.numberOfEvidence || 3);
  }
  return (
    <>
      <TextInput
        className={form.column}
        source="suspectsCode"
        validate={validateCode}
        disabled={iscompleted}
      />
      <SelectInput
        className={form.column}
        source="numberOfEvidence"
        choices={evidenceNumber}
        validate={required()}
        // onChange={handleEvidenceNumberChange}
        disabled={iscompleted}
      />
      <div className={form.column}>
        <TextInput
          className={form.halfColumnLeft}
          source="evidenceCode1"
          validate={validateCode}
          disabled={iscompleted}
        />
        <SelectInput
          className={form.halfColumnRight}
          source="evidenceUnlock1"
          choices={evidenceUnlockChoices}
          defaultValue="silver-lock"
          disabled={true}
        />
      </div>

      <div className={form.column}>
        <TextInput
          className={form.halfColumnLeft}
          source="evidenceCode2"
          validate={validateCode}
          disabled={iscompleted}
        />
        <SelectInput
          className={form.halfColumnRight}
          source="evidenceUnlock2"
          choices={evidenceUnlockChoices}
          defaultValue="silver-lock"
          disabled={true}
        />
      </div>

      {formData.getState().values.numberOfEvidence >= 3 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode3"
            validate={formData.getState().values.numberOfEvidence >= 3 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock3"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 4 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode4"
            validate={formData.getState().values.numberOfEvidence >= 4 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock4"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 5 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode5"
            validate={formData.getState().values.numberOfEvidence >= 5 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock5"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 6 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode6"
            validate={formData.getState().values.numberOfEvidence >= 6 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock6"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 7 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode7"
            validate={formData.getState().values.numberOfEvidence >= 7 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock7"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 8 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode8"
            validate={formData.getState().values.numberOfEvidence >= 8 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock8"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 9 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode9"
            validate={formData.getState().values.numberOfEvidence >= 9 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock9"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      {formData.getState().values.numberOfEvidence >= 10 && (
        <div className={form.column}>
          <TextInput
            className={form.halfColumnLeft}
            source="evidenceCode10"
            validate={formData.getState().values.numberOfEvidence >= 10 ? validateCode : validateCodeOptional}
            disabled={iscompleted}
          />
          <SelectInput
            className={form.halfColumnRight}
            source="evidenceUnlock10"
            choices={evidenceUnlockChoices}
            defaultValue="silver-lock"
            disabled={true}
          />
        </div>
      )}
      <NumberInput
        className={form.column}
        source="attendingActors"
        validate={required()}
        disabled={iscompleted}
      />
      <TextInput
        className={form.column}
        source="discountCode"
        validate={required()}
        disabled={iscompleted}
      />
      <TextInput
        label="Sleuth Code"
        className={form.column}
        source="bypassCode"
        validate={validateCode}
      />
      <ImageInput
        className={form.column}
        source="plotImage"
        validate={required()}
        maxSize={1500000}
        placeholder={<h5>Drop a picture to upload, or click to select it.<br></br>Max size 1.5MB</h5>}
      // options={{
      //   disabled:true
      // }}
      >
        <PreviewImageField />
      </ImageInput>
      <RichTextInput
        label="Plot Description"
        className={form.column}
        source="plotIntroduction"
        validate={required()}
        multiline
        toolbar={RichTextToolbar}
      />
      <TextInput
        className={form.column}
        source="dressCode"
        disabled={iscompleted}
      />
    </>
  )
}

export default EventPlotForm;
